import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const ColStyledImageContainer = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      ${mediumUp && `
        padding-right: ${rem(32)};
      `}
    `;
  }}
`;

export const ColStyledContentContainer = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      ${mediumUp && `
        padding-left: ${rem(16)};
      `}
    `;
  }}
`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    let thisMaxWidth = rem(160);

    if(mediumUp){
      thisMaxWidth = 'unset';
    }

    return css` 
      margin: 0 auto;
      margin-bottom: ${mediumUp ? 0 : rem(32)};
      max-width: ${thisMaxWidth};
    `;
  }}
`;

export const TypographyStyledHeading = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      text-align: ${mediumUp ? 'left' : 'center'};
    `;
  }}
`;